import { action } from '@ember/object';
import { oneWay } from '@ember/object/computed';
import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import { all } from 'rsvp';
import FiltersService from 'cio/services/filters';
import DS from 'ember-data';

export default class SubjectRoute extends Route {
  @service filters!: FiltersService;
  @service store!: DS.Store;

  crumb() {
    return {
      name: oneWay('model.campaign.name'),
      path: 'person.subjects.subject',
      model: this.modelFor(this.routeName),
    };
  }

  scrollOnActivate = false;

  model(params: { subject_id: string }) {
    return this.store.findRecord('subject', params.subject_id);
  }

  afterModel() {
    return all([this.store.findAll('short-segment'), this.filters.process.perform()]);
  }

  @action
  reloadModel() {
    return this.refresh();
  }
}
